<template>
  <div class="container">
    <a-card style="width: 500px">
      <div>
        <img src="../assets/image/logo.png" alt class="logo" />
      </div>
      <div class="title">登录</div>
      <a-form-model
        :model="form"
        :label-col="{ span: 4 }"
        :wrapper-col="{ span: 18 }"
      >
        <a-form-model-item label="用户名">
          <a-input
            v-model="form.email"
            placeholder="请使用向源码提供的邮箱进行登录"
          />
        </a-form-model-item>
        <a-form-model-item label="验证码" :wrapper-col="{ span: 10 }">
          <div class="btn-line">
            <a-input v-model="form.code" />
            <div class="btn">
              <a-button :disabled="sending || sent || !form.email" @click="sendCode">
                <span v-if="!sending && !sent">发送验证码</span>
                <span v-else-if="sent">{{ clockTick }}秒后再次发送</span>
                <span v-else-if="sending">发送中</span>
              </a-button>
            </div>
          </div>
        </a-form-model-item>
      </a-form-model>
      <a-button
        size="large"
        type="primary"
        class="long"
        :disabled="!form.email || !form.code"
        @click="login"
      >
        登录</a-button
      >
    </a-card>
    <div class="card"></div>
  </div>
</template>

<script>
import { sendCode, login } from '@/api';
import { setToken, setUserInfo } from '@/assets/js/auth';

export default {
  data() {
    return {
      form: {
        email: '',
        code: '',
      },
      sending: false,
      sent: false,
      clockTick: 0,
    };
  },
  mounted() {
  },
  methods: {
    sendCode() {
      this.sending = true;
      sendCode({email: this.form.email}).then((res) => {
        if(res.code === 200) {
          this.setClock();
          this.$message.success('已向您提供的邮箱和手机发送验证码')
        }
      }).finally(() => {
        this.sending = false;
      });
    },
    login() {
      login(this.form).then((res) => {
        if (res.code === 200) {
          this.$store.dispatch('setToken', res.data.token)
          this.$store.dispatch('setUserInfo', {portfolioName: res.data.portfolioName})
          this.$message.success('登陆成功');
          this.$router.push('/gather');
        }
      });
    },
    setClock() {
      this.clockTick = 60;
      this.sent = true;
      this.intervalId = setInterval(() => {
        this.clockTick--;
        if (this.clockTick <= 0) {
          clearInterval(this.intervalId);
          this.sent = false;
        }
      }, 1000);
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 150px;
}
.logo {
  width: 150px;
}
.title {
  font-weight: bold;
  margin: 20px 0;
}
.flex {
  display: flex;
  justify-content: center;
}
.btn-line {
  position: relative;
  .btn {
    position: absolute;
    top: 0;
    right: -150px;
  }
}
.long {
  margin: 50px 0;
  width: 80%;
}
</style>
